import { getMenu } from './menus'

// Canonical pantry items derived from the 7 menus + supplement stack.
// unit: 'g' | 'ml' | 'pcs'. Used to drive the Stock page: pantry inventory
// with real quantities, and the "what's short for tomorrow" shopping list.
export const GROCERY_ITEMS = {
  moongDal: { name: 'Moong dal (dry)', category: 'Dals & legumes', unit: 'g' },
  toorDal: { name: 'Toor dal (dry)', category: 'Dals & legumes', unit: 'g' },
  rajma: { name: 'Rajma (dry)', category: 'Dals & legumes', unit: 'g' },
  chole: { name: 'Chole / chickpeas (dry)', category: 'Dals & legumes', unit: 'g' },
  soya: { name: 'Soya chunks / granules', category: 'Dals & legumes', unit: 'g' },
  sprouts: { name: 'Moong sprouts', category: 'Dals & legumes', unit: 'g' },
  besan: { name: 'Besan (gram flour)', category: 'Grains & flours', unit: 'g' },
  poha: { name: 'Poha', category: 'Grains & flours', unit: 'g' },
  daliya: { name: 'Daliya (broken wheat)', category: 'Grains & flours', unit: 'g' },
  atta: { name: 'Atta (wheat flour)', category: 'Grains & flours', unit: 'g' },
  milldAtta: { name: 'MillD High Protein Atta', category: 'Grains & flours', unit: 'g' },
  idBatter: { name: 'iD Fresh Protein Rich Idli/Dosa Batter', category: 'Grains & flours', unit: 'g' },
  rice: { name: 'Rice', category: 'Grains & flours', unit: 'g' },
  paneer: { name: 'High-protein paneer', category: 'Dairy & soy', unit: 'g' },
  tofu: { name: 'Firm tofu', category: 'Dairy & soy', unit: 'g' },
  curd: { name: 'Curd', category: 'Dairy & soy', unit: 'g' },
  greekYogurt: { name: 'Greek yogurt (hung curd)', category: 'Dairy & soy', unit: 'g' },
  milk: { name: 'Toned milk', category: 'Dairy & soy', unit: 'ml' },
  highProteinBread: { name: 'High-Protein Bread (The Health Factory)', category: 'Grains & flours', unit: 'g' },
  peanuts: { name: 'Peanuts (roasted, for chutney)', category: 'Extras', unit: 'g' },
  saladVeg: { name: 'Salad veg (cucumber, tomato, onion, carrot)', category: 'Produce', unit: 'g' },
  banana: { name: 'Banana', category: 'Produce', unit: 'pcs' },
  apple: { name: 'Apple', category: 'Produce', unit: 'pcs' },
  orange: { name: 'Orange', category: 'Produce', unit: 'pcs' },
  guava: { name: 'Guava', category: 'Produce', unit: 'pcs' },
  potato: { name: 'Potato', category: 'Produce', unit: 'g' },
  mixedVeg: { name: 'Mixed vegetables', category: 'Produce', unit: 'g' },
  tomato: { name: 'Tomato', category: 'Produce', unit: 'g' },
  onion: { name: 'Onion', category: 'Produce', unit: 'g' },
  cucumber: { name: 'Cucumber', category: 'Produce', unit: 'g' },
  carrot: { name: 'Carrot', category: 'Produce', unit: 'g' },
  cabbage: { name: 'Cabbage', category: 'Produce', unit: 'g' },
  cauliflower: { name: 'Cauliflower', category: 'Produce', unit: 'g' },
  spinach: { name: 'Spinach (palak)', category: 'Produce', unit: 'g' },
  methi: { name: 'Fenugreek leaves (methi)', category: 'Produce', unit: 'g' },
  brinjal: { name: 'Brinjal (baingan)', category: 'Produce', unit: 'g' },
  capsicum: { name: 'Capsicum', category: 'Produce', unit: 'g' },
  greenBeans: { name: 'Green beans (french beans)', category: 'Produce', unit: 'g' },
  greenPeas: { name: 'Green peas (matar)', category: 'Produce', unit: 'g' },
  bhindi: { name: 'Bhindi (okra)', category: 'Produce', unit: 'g' },
  lauki: { name: 'Bottle gourd (lauki)', category: 'Produce', unit: 'g' },
  pumpkin: { name: 'Pumpkin (kaddu)', category: 'Produce', unit: 'g' },
  beetroot: { name: 'Beetroot', category: 'Produce', unit: 'g' },
  radish: { name: 'Radish (mooli)', category: 'Produce', unit: 'g' },
  coriander: { name: 'Coriander leaves (dhania)', category: 'Produce', unit: 'g' },
  oats: { name: 'Oats', category: 'Extras', unit: 'g' },
  peanutButter: { name: 'Peanut butter', category: 'Extras', unit: 'g' },
  almonds: { name: 'Almonds', category: 'Extras', unit: 'g' },
  ghee: { name: 'Ghee', category: 'Extras', unit: 'g' },
  cheese: { name: 'Cheese', category: 'Extras', unit: 'g' },
}

export const SUPPLEMENT_ITEMS = {
  whey: { name: 'Whey Protein (MuscleBlaze Biozyme)', unit: 'scoop' },
  creatine: { name: 'Creatine Monohydrate (AS-IT-IS Creapure)', unit: 'serving' },
  b12: { name: 'Vitamin B12 (Nurokind-OD)', unit: 'tablet' },
  omega3: { name: 'Omega-3 (algae)', unit: 'serving' },
  d3: { name: 'Vitamin D3 60K (Uprise)', unit: 'dose' },
}

// Menus whose dal/legume needs an overnight soak - worth a "do this tonight"
// nudge the evening before, per the plan's own recipe notes. Menu A (idli +
// MillD roti) and Menu B (paneer sandwich) use paneer/tofu/idli batter, none
// of which need an overnight soak, so this is empty for the current plan.
export const PREP_AHEAD = {}

// Total quantity of each grocery item a whole day's menu needs, summed
// across all 5 meals (e.g. milk appears in 3 meals - this adds them up).
export function getIngredientsForMenu(menuNumber) {
  const menu = getMenu(menuNumber)
  const totals = {}
  for (const meal of menu.meals) {
    for (const { key, qty } of meal.ingredients || []) {
      totals[key] = (totals[key] || 0) + qty
    }
  }
  return Object.entries(totals).map(([key, qty]) => ({ key, qty, ...GROCERY_ITEMS[key] }))
}
